<script>
import {mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const surveyApi = ClientFactory.get("surveys");
export default {
    async created() {
        let surveyId = this.$route.params.id || -1;
        // Force reload by browser => redirect to surveys management screen.
        if(surveyId === -1) {
           return this.$router.push('/surveys/list').catch(() => {})
        }
        this.survey = await this.getSurveyResultById(surveyId);
    },
    data () {
        return {
            survey: {
                summary: {},
                questions: []
            },
        }
    },
    methods: {
        ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
        async getSurveyResultById(id) {
            this.loading(this.$vs)
            this.survey_id = id;
            let survey = await surveyApi.getResults(id);
            if(typeof survey.error !== 'undefined') {
                return this.notify({
                    error: true,
                    text: survey.error
                })
            }
            this.closeLoading()
            return survey;
        }
    },
    computed: {
        randomClass () {
            return 'question-result-' + Math.floor(Math.random()*(6-1+1)+1)
        }
    }
    
}
</script>

<template>
    <div class="survey-result-containner">
        <CCard>
            <CCardHeader>
               <span class="card-header-title">{{survey.summary.name}}</span>
               <p class="mt-2">{{survey.summary.description}}</p>
               Trạng thái:
                <CBadge v-if="survey.summary.is_open == 1" color="success">Đang mở</CBadge>
                <CBadge v-else color="danger">Đã kết thúc</CBadge>
            </CCardHeader>
            <CCardBody>
                <p>Danh sách tham gia khảo sát:</p>
                <CListGroup class="particapants" flush>
                    <CListGroupItem v-for="p, index in survey.summary.participantsSummary" :key="index" >{{index + 1}}. {{p.full_name}}</CListGroupItem>
                </CListGroup>
            </CCardBody>
        </CCard>
        <CCard v-for="q, index in survey.questions" :key="index">
            <CCardHeader>
               <h5>Câu hỏi {{index + 1}}: {{q.question_text}}</h5>
               <em v-if="q.input_type_id == 3">Danh sách nội dung do người thực hiện khảo sát gửi lên.</em>
            </CCardHeader>
            <CCardBody>
                <CListGroup v-if="q.input_type_id == 3" flush>
                    <CListGroupItem v-for="answer, i in q.results" :key="i" >
                        <span v-if="answer.content !== null">{{i + 1}}. {{answer.content}}</span>
                    </CListGroupItem>
                </CListGroup>
                <CListGroup v-else v-for="answer, i in q.results" :key="i" >    
                    <CListGroupItem :class="randomClass" >
                        <CRow>
                            <CCol md="10"><span class="font-weight-bold"> {{answer.content}} </span> </CCol>
                            <CCol md="2"> <span class="float-right mt-0"> {{answer.count}} người chọn </span></CCol>
                        </CRow>
                    </CListGroupItem>
                </CListGroup>
            </CCardBody>
        </CCard>
       <vs-button square class="mb-3 custom_btn_search" @click="()=> {this.$router.go(-1)}"><i class='bx bx-left-arrow-alt'></i> &nbsp; Quay lại</vs-button>
    </div>
</template>

<style>
 .particapants {
    max-height: 220px; 
    overflow: auto
 }

.question-result-1 {
    margin-top: 5px;
    border-left: 15px solid var(--primary);
}
.question-result-2 {
    margin-top: 5px;
    border-left: 15px solid var(--secondary);
}
.question-result-3 {
    margin-top: 5px;
    border-left: 15px solid var(--success);
}
.question-result-4 {
    margin-top: 5px;
    border-left: 15px solid var(--info);
}
.question-result-5 {
    margin-top: 5px;
    border-left: 15px solid var(--warning);
}
.question-result-6 {
    margin-top: 5px;
    border-left: 15px solid var(--danger);
}
</style>